import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';

export default function Popup(props) {

  const { title, text, image, closeFunction, closeFunctionDisable = false } = props;
  const { t } = useTranslation();

  const router = useRouter();

  return (
    <div className="popup-container">
      <div
        className="popup-background"
        onClick={() => { if(!closeFunctionDisable) closeFunction(false); }}
      />
      <div className="popup-content">
        <div className="popup-close-container">
          {
            !closeFunctionDisable && (
              <span
                className="popup-close-icon"
                onClick={() => {if(!closeFunctionDisable) closeFunction(false); }}
              />
            )
          }

        </div>
        {
          title ?
          <h4 className="popup-title" dangerouslySetInnerHTML={{ __html: title }} />
          : null
        }
        {
          text ?
          <p className="popup-text little-text">{text}</p>
          : null
        }
        {
          image ?
          <img className="popup-image" src={image} />
          : null
        }
      </div>
    </div>
  )
}
